import type { Staff } from '@/lib/types';

/**
 * Tri-state status pill: Inactive (past active_to), Pending (future
 * active_from), or Active. The "Pending" case was added with migration
 * 0096 when active_from became routinely editable -- it tells managers
 * a staff member is on the roster but not yet eligible for shifts.
 */
export function StaffStatusBadge({ staff }: { staff: Staff }) {
  const today = new Date().toISOString().slice(0, 10);

  if (staff.active_to !== null && staff.active_to <= today) {
    return (
      <span className="inline-flex items-center rounded-full bg-muted/60 px-2 py-0.5 text-xs font-medium text-muted-foreground">
        Inactive
      </span>
    );
  }
  if (staff.active_from > today) {
    return (
      <span
        className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700"
        title={`Starts ${staff.active_from}`}
      >
        Pending
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700">
      Active
    </span>
  );
}
